import type { ConsentDocKind } from '@/shared/data-types';
import { UI_TEXT } from '@/shared/languages';
import { FullScreenDialog } from '@/shared/ui';
import { ConsentDocContent } from './consent-doc-content';

/** kind 별 정적 라벨 — 로드 전에도 즉시 쓸 수 있는 a11y 제목(가시 제목은 본문 h1 = BE `name`). */
const CONSENT_DOC_TITLE: Record<ConsentDocKind, string> = {
  terms: UI_TEXT.AGREEMENT_TERMS_TITLE,
  privacyCollection: UI_TEXT.CONSENT_DOC_PRIVACY_COLLECTION_TITLE,
  privacyThirdParty: UI_TEXT.CONSENT_DOC_PRIVACY_THIRD_PARTY_TITLE,
  privacy: UI_TEXT.AGREEMENT_PRIVACY_TITLE,
  marketing: UI_TEXT.SETTINGS_MARKETING,
  refund: UI_TEXT.AGREEMENT_REFUND_TITLE,
};

export interface ConsentDocModalProps {
  kind: ConsentDocKind;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * 지목 약관 원문 모달 — `ConsentModal`(문서를 이미 쥔 표면용)과 달리 **kind 만 받아 스스로 조회**한다.
 * 목록을 들고 있지 않은 표면(`/help`·standalone 푸터)이 진입점.
 */
export function ConsentDocModal({ kind, open, onOpenChange }: ConsentDocModalProps) {
  return (
    <FullScreenDialog open={open} onOpenChange={onOpenChange} title={CONSENT_DOC_TITLE[kind]}>
      <ConsentDocContent kind={kind} />
    </FullScreenDialog>
  );
}
